import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Tab, Nav, Table, Spinner, Form, Button } from 'react-bootstrap';
import moment from 'moment';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import * as Icon from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import Pagination from '../Common/Pagination';
const TotalCalling = () => {

    const Zoneoptions = {
        page: {
            margin: 10,
        },
        filename: 'zone Wise Calling.pdf'
    };
    const UserOptions = {
        page: {
            margin: 10,
        },
        filename: 'User Wise Calling.pdf'
    };

    const financialYear = useSelector((state) => state.activeData.financialYear);
    const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);

    const zoneWiseTarget = useRef();
    const userWiseTarget = useRef();

    const [key, setKey] = useState('ZoneWise');
    const [zoneLoader, setZoneLoader] = useState(false);
    const [userLoader, setUserLoader] = useState(false);
    const [zoneWiseCalling, setZoneWiseCalling] = useState('');
    const [userWiseCalling, setUserWiseCalling] = useState('');
    const [date, setDate] = useState('');

    const [zone, setZone] = useState('');
    const [zoneList, setZoneList] = useState('');

    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [startDateErr, setStartDateErr] = useState("")

    // States for Pagination ----------
    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState(0);

    // function for pagination

    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1);
        setDocPerPage(docsPageProp);
    };

    useEffect(() => {
        getZone();
    }, [])

    useEffect(() => {
        setPageNo(1);
    }, [date, zone, startDate, endDate]);

    useEffect(() => {
        if (!activeKey) return;

        if (key === "ZoneWise") {
            getZoneWiseTotalCalling();
        } else {
            getUserWiseTotalCalling();
        }

    }, [date, zone, activeKey, endDate, docPerPage, pageNo, key,financialYear]);

    const getZone = async () => {
        await fetch(process.env.REACT_APP_BASE_URL + '/zoneData/getZoneData', {
            method: "GET"
        }).then((res) => res.json()).then((response) => {
            setZoneList(response.data);
        }).catch((err) => {
            console.log("err while gettting zone=>", err);
        })
    }

    // zone wise data
    const getZoneWiseTotalCalling = async () => {
        setZoneLoader(true);
        await fetch(process.env.REACT_APP_BASE_URL + '/tc/zoneWiseReportv2', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                zonename: zone,
                callingDate: date,
                financialYear: financialYear,
                fromDate: startDate,
                toDate: endDate,
                documentsPerPage: docPerPage,
                page: pageNo,
            })
        }).then((res) => res.json()).then((response) => {
            setZoneWiseCalling(response);
            setNoOfPages(response.noOfPages || 0);
            setZoneLoader(false);
        }).catch((Err) => {
            console.log("Err while getting zone wise calling", Err);
            setZoneLoader(false);
        })
    }

    // user wise data
    const getUserWiseTotalCalling = async () => {
        setUserLoader(true);
        await fetch(process.env.REACT_APP_BASE_URL + '/user/getCombinedCallingUsersv2', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                zonename: zone,
                callingDate: date,
                financialYear: financialYear,
                fromDate: startDate,
                toDate: endDate,
                documentsPerPage: docPerPage,
                page: pageNo,
            })
        }).then((res) => res.json()).then((response) => {
            setUserWiseCalling(response);
            setNoOfPages(response.noOfPages || 0);
            setUserLoader(false);
        }).catch((Err) => {
            console.log("Err while getting user wise calling", Err);
            setUserLoader(false);
        })
    }

    const generateZoneWiseExcel = (data, fileName) => {
        const formattedData = data?.data?.map(item => ({
            'Zone': item.zone,
            'Call Connected': item.callConnect,
            'Call Not Connected': item.callNotConnect,
            'Dial Call Connected': item.dialCallConnects,
            'Dial Call Not Connected': item.dialCallNotConnects,
            'Total Calls': item.totalCalls
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(formattedData);

        ws['!cols'] = [
            { wch: 20 }, { wch: 15 }, { wch: 20 },
            { wch: 20 }, { wch: 22 }, { wch: 12 }
        ];

        XLSX.utils.book_append_sheet(wb, ws, "Zone Report");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const downloadFullZoneWiseExcel = async () => {
        try {
            let allData = [];
            let currentPage = 1;
            let totalPages = 1;

            do {
                const res = await fetch(process.env.REACT_APP_BASE_URL + '/tc/zoneWiseReportv2', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        zonename: zone,
                        callingDate: date,
                        financialYear: financialYear,
                        fromDate: startDate,
                        toDate: endDate,
                        documentsPerPage: 1000000,
                        page: 1,
                    })
                });

                const response = await res.json();

                if (response?.data?.length > 0) {
                    allData = [...allData, ...response.data];
                }

                totalPages = response.noOfPages || 1;
                currentPage++;

            } while (currentPage <= totalPages);

            generateZoneWiseExcel({ data: allData }, 'ZoneWise_Calling_Report');

        } catch (err) {
            console.log("Excel download error:", err);
        }
    };

    const generateUserWiseExcel = (data, fileName) => {
        const formattedData = data?.map((item, index) => ({
            'Sr. No': index + 1,
            'Name': item.name || '-',
            'Mobile': item.contactNo || '-',
            'Zone': `${item.zonename || ''}-${item.zoneno || ''}`.replace(/-$/, ''),
            'Gat': Array.isArray(item.gatname) ? item.gatname.join(', ') : '-',
            'Role': Array.isArray(item.usertype_name)
                ? item.usertype_name[0]
                : item.usertype_name || '-',
            'Calling Count': item.callingCount || 0,
            'Talk Duration': item.talkDuration || '-'
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(formattedData);

        XLSX.utils.book_append_sheet(wb, ws, "User Report");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const downloadFullUserWiseExcel = async () => {
        try {
            let allData = [];
            let currentPage = 1;
            let totalPages = 1;

            do {
                const res = await fetch(process.env.REACT_APP_BASE_URL + '/user/getCombinedCallingUsersv2', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        zonename: zone,
                        callingDate: date,
                        financialYear: financialYear,
                        fromDate: startDate,
                        toDate: endDate,
                        documentsPerPage: 1000000,
                        page: 1,
                    })
                });

                const response = await res.json();

                if (response?.data?.length > 0) {
                    allData = [...allData, ...response.data];
                }

                totalPages = response.noOfPages || 1;
                currentPage++;

            } while (currentPage <= totalPages);

            generateUserWiseExcel(allData, 'UserWise_Calling_Report');

        } catch (err) {
            console.log("Excel download error:", err);
        }
    };

    return (
        <div className='TotalCalling mb-5'>
            <Tab.Container activeKey={key} onSelect={(k) => {
                setKey(k);
                setPageNo(1);
                // setDocPerPage(50);
                setZone("");
                setStartDate("");
                setEndDate("");
                setDate("");
                setZoneWiseCalling([]);
                setUserWiseCalling([]);
            }}>
                <Row className='justify-content-between align-items-center'>
                    <Col md={4} className='d-flex mb-3 mb-md-0'>
                        <div className='me-3'>
                            <Form.Label>Search by Start date</Form.Label>
                            <Form.Control type="date" value={startDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => {
                                setStartDateErr("")
                                setStartDate(moment(e.target.value).format("YYYY-MM-DD"))
                            }} />
                        </div>
                        <div className='me-3'>
                            <Form.Label>Search by End Date</Form.Label>
                            <Form.Control type="date" value={endDate} min={startDate ? startDate : ""} max={new Date().toISOString().split("T")[0]} onChange={(e) => {
                                if (startDate == "") {
                                    setStartDateErr("Select Start Date First")
                                    return

                                }
                                setEndDate(moment(e.target.value).format("YYYY-MM-DD"))
                            }} />
                            {startDateErr && (
                                <small className="text-danger">
                                    {startDateErr}
                                </small>
                            )}
                        </div>
                        <div>
                            <Form.Label>Search by zone</Form.Label>
                            <Form.Select value={zone} onChange={(e) => setZone(e.target.value)} style={{ width: '250px', marginBottom: "10px" }}>
                                <option value="" selected disabled>Select zone</option>
                                {
                                    zoneList !== undefined && zoneList.length > 0 && zoneList !== null ?
                                        zoneList?.map((row) => {
                                            return (
                                                <option value={row?.zonename}>{row?.zonename + -row?.zoneno}</option>
                                            )
                                        }) : <option value=""></option>
                                }
                            </Form.Select>
                        </div>
                    </Col>
                    <Col md={3}>
                        <Nav variant="pills" className="flex-row justify-content-end">
                            <Nav.Item>
                                <Nav.Link eventKey="ZoneWise">Zone Wise</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="UserWise">User Wise</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>

                </Row>


                <Tab.Content className='mt-3 mt-md-0'>
                    <Tab.Pane eventKey="ZoneWise">

                        <Button className='btn-cancel mx-auto' onClick={downloadFullZoneWiseExcel}>
                            <Icon.ArrowDownCircle size={14} className='me-2' />Download ZoneWise Excel
                        </Button>

                        <div className="container tbl-container p-0 mt-4" ref={zoneWiseTarget}>
                            <div className="row tbl-fixed p-0">
                                <Table responsive="lg" hover>
                                    <thead>
                                        <tr>
                                            <th>Sr.No</th>
                                            <th>Zone</th>
                                            <th>Call Connected</th>
                                            <th>Call Not Connected</th>
                                            <th>Dail Call Connected</th>
                                            <th>Dail Call Not Connected</th>
                                            <th>Totals</th>
                                        </tr>
                                    </thead>

                                    {zoneLoader ? (
                                        <Spinner variant="primary" className="mt-2" />
                                    ) : (
                                        <tbody>
                                            {zoneWiseCalling?.data !== null && zoneWiseCalling?.data !== undefined && zoneWiseCalling?.data?.length > 0
                                                ? zoneWiseCalling?.data?.map((row, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{index + 1 + docPerPage * (pageNo - 1)}</td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{row?.zone}</td>
                                                            <td>{row?.callConnect}</td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{row?.callNotConnect}</td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{row?.dialCallConnects}</td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{row?.dialCallNotConnects}</td>
                                                            <td>{row?.totalCalls}</td>
                                                        </tr>
                                                    );
                                                })
                                                : "No calling data found"}
                                        </tbody>
                                    )}
                                </Table>
                            </div>
                            <Row>
                                <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                    <h6 className="text-start mb-0">
                                        <Icon.People className="me-2" />
                                        Total - <strong>{zoneWiseCalling.totalCount || 0}</strong>
                                    </h6>
                                </Col>
                                <Col md={8} className="d-flex justify-content-end">
                                    <Pagination
                                        currentPage={pageNo}
                                        totalPages={noOfPages}
                                        onPageChange={handlePageChange}
                                        onDocsPerPage={handleDocsPerPage}
                                        docsPerPage={docPerPage}
                                    />
                                </Col>
                            </Row>
                        </div >
                    </Tab.Pane>

                    <Tab.Pane eventKey="UserWise">

                        <Button className='btn-cancel mx-auto' onClick={downloadFullUserWiseExcel}>
                            <Icon.ArrowDownCircle size={14} className='me-2' />Download UserWise Excel
                        </Button>

                        <div className="container tbl-container p-0 mt-4" ref={userWiseTarget}>
                            <div className="row tbl-fixed p-0">
                                <Table responsive="lg" hover>
                                    <thead>
                                        <tr>
                                            <th>Sr.No</th>
                                            <th>Name</th>
                                            <th>Mobile</th>
                                            <th>Zone</th>
                                            <th>Gat</th>
                                            <th>Role</th>
                                            <th>Calling Count</th>
                                            <th>Talk Duration</th>
                                        </tr>
                                    </thead>

                                    {userLoader ? (
                                        <Spinner variant="primary" className="mt-2" />
                                    ) : (
                                        <tbody>
                                            {userWiseCalling?.data !== null && userWiseCalling?.data !== undefined && userWiseCalling?.data?.length > 0
                                                ? userWiseCalling?.data?.map((row, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{index + 1 + docPerPage * (pageNo - 1)}</td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{row?.name}</td>
                                                            <td>{row?.contactNo}</td>
                                                            <td style={{ whiteSpace: 'nowrap' }}>{`${row?.zonename}-${row?.zoneno ?? ''}`}</td>
                                                            <td style={{ maxWidth: '150px', wordWrap: 'break-word' }}>{row?.gatname.map((row) => row).join(', ')}</td>
                                                            <td>{row?.usertype_name}</td>
                                                            <td>{row?.callingCount}</td>
                                                            <td>{row?.talkDuration}</td>
                                                        </tr>
                                                    );
                                                })
                                                : "No data found"}
                                        </tbody>
                                    )}
                                </Table>
                            </div>.
                            <Row>
                                <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                    <h6 className="text-start mb-0">
                                        <Icon.People className="me-2" />
                                        Total - <strong>{userWiseCalling.totalCount || 0}</strong>
                                    </h6>
                                </Col>
                                <Col md={8} className="d-flex justify-content-end">
                                    <Pagination
                                        currentPage={pageNo}
                                        totalPages={noOfPages}
                                        onPageChange={handlePageChange}
                                        onDocsPerPage={handleDocsPerPage}
                                        docsPerPage={docPerPage}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Tab.Pane>


                </Tab.Content>
            </Tab.Container>
        </div>
    )
}

export default TotalCalling;